import Scene = Phaser.Scene;
import Image = Phaser.GameObjects.Image;
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import {Fonts} from "@/constants/font";
import SContainer from "@/cmp/s-container";
import CU from "@/utils/c-u";
export default class TextButton extends SContainer {

    private callback: (() => unknown) | undefined = undefined;
    private buttonImage!: Image;

    constructor(scene: Scene, x: number, y: number, key: string, text: string,
                color: string = '#f9bd8c', fontStyle: string = 'bold') {
        super(scene, x, y);

        const self = this;

        if (Keys.UI_LOGIN_BUTT === key || Keys.GREEN_HORIZONTAL_BUTTON === key || Keys.UI_LANG_ACC_BUTT === key || Keys.UI_LANG_BUTT_AVAL === key || Keys.UI_LANG_BUTT_UNAVAL === key) { // hack
            this.buttonImage = SpriteUtils.addImage(this.scene, 0, 0, key).setInteractive();
        } else {
            this.buttonImage = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_UI, key).setInteractive();
        }

        this.buttonImage.on('pointerdown', () => {
            SpriteUtils.scaleOriginal(this.buttonImage, this.buttonImage.scale * 1.02);
        });
        this.buttonImage.on('pointerup', () => {
            SpriteUtils.scaleOriginal(this.buttonImage, this.buttonImage.scale / 1.02);
            if (self.callback != null) {
                self.callback();
            }
        });

        let size: number = text.length < 20 ? 15 : 11;
        const buttonText = this.scene.add.text(0, 0, text,{
            fontSize: String(Math.ceil(size * CU.S)) + 'pt',
            color: color,
            fontFamily: 'Arial',
            align: 'center',
            fontStyle: fontStyle,
            wordWrap: { width: this.buttonImage.width - 30, useAdvancedWrap: true }
        }).setOrigin(0.5, 0.5);
        if (key === Keys.GREEN_HORIZONTAL_BUTTON){ // hack
                buttonText.setColor('#ffffff');
                buttonText.setFontSize(22 * CU.S);
                buttonText.setFontStyle('bold');
                buttonText.setFontFamily(Fonts.MYRIADPRO_REGULAR);
        }
        buttonText.setLineSpacing(2);
        buttonText.setShadow(-1, 2, '#000000');


        for (let obj of [this.buttonImage, buttonText]) {
            obj.setOrigin(0.5, 0.5);
            this.add(obj);
        }
    }

    public setEnabled(enabled: boolean): void {
        if (enabled) {
            this.buttonImage.resetPipeline();
        } else {
            this.buttonImage.setPipeline('Gray');
        }
    }

    public setCallback(callback: () => unknown): void {
        this.callback = callback;
    }

}
